import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import {
  IonApp,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { map, information, camera, list } from 'ionicons/icons';
import Tab1 from './pages/Tab1';
import Tab2 from './pages/Tab2';
import Tab3 from './pages/Tab3';
import Tab4 from './pages/Tab4';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

const App: React.FC = () => (
  <IonApp>
    <IonReactRouter>
      <IonTabs>
        <IonRouterOutlet>
          <Route path="/infos" component={Tab1} exact={true} />
          <Route path="/scan" component={Tab2} exact={true} />
          <Route path="/carte" component={Tab3} exact={true} />
          <Route path="/resultats" component={Tab4} />
          <Route path="/" render={() => <Redirect to="/scan" />} exact={true} />
        </IonRouterOutlet>
        <IonTabBar slot="bottom">
          <IonTabButton tab="tab1" href="/infos">
            <IonIcon icon={information} />
            <IonLabel>Infos</IonLabel>
          </IonTabButton>
          <IonTabButton tab="tab2" href="/scan">
            <IonIcon icon={camera} />
            <IonLabel>Scanner</IonLabel>
          </IonTabButton>
          <IonTabButton tab="tab3" href="/carte">
            <IonIcon icon={map} />
            <IonLabel>Carte</IonLabel>
          </IonTabButton>
          <IonTabButton tab="tab4" href="/resultats">
            <IonIcon icon={list} />
            <IonLabel>Classement</IonLabel>
          </IonTabButton>
        </IonTabBar>
      </IonTabs>
    </IonReactRouter>
  </IonApp>
);

export default App;
